<homey-page-title title="Not found"/>
<p class="mb-8">Unfortunately this page could not be found...</p>
<a class="w-full" pButton routerLink="/" [replaceUrl]="true" label="Return to Home"></a>
